import React from 'react';
// import { useLanguage } from 'src/LanguageContext';
import { translate } from '../translate';
import { ExclamationTriangleIcon, HomeIcon } from '@heroicons/react/24/outline';

const ErrorBoundaryFallback = ({ eventId } = {}) => {
  const language = localStorage.getItem('languageV2') || 'en';

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          {/* Error Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100">
            <ExclamationTriangleIcon className="h-10 w-10 text-red-600" aria-hidden="true" />
          </div>
          
          {/* Error Title */}
          <h2 className="mt-6 text-2xl font-bold text-gray-900">
            {translate('errorOccurred', language)}
          </h2>
          
          {/* Error Message */}
          <p className="mt-4 text-base text-gray-600 leading-relaxed">
            {translate('errorMessage', language)}
          </p>
          
          {/* Back to Home Button */}
          <div className="mt-8">
            <button
              onClick={handleGoHome}
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-base font-medium rounded-md text-white bg-watsPrimary hover:bg-[#0d5a4a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-watsPrimary transition-colors duration-200"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <HomeIcon className="h-5 w-5 text-white group-hover:text-gray-200" aria-hidden="true" />
              </span>
              {translate('backToHome', language)}
            </button>
          </div>
          
          {/* Additional Help Text */}
          <p className="mt-4 text-sm text-gray-500">
            {translate('clickToGoHome', language)}
          </p>
          {eventId ? (
            <p className="mt-2 text-xs text-gray-400 select-all">
              {eventId}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundaryFallback; 